import api from './axiosConfig';
import type { ContextoPOS } from './onboardingService';

export interface LoginRequest {
  email: string;
  password: string;
  /** Token de Cloudflare Turnstile (solo modo Ecolab). */
  turnstileToken?: string;
}

export interface LoginResponse {
  token: string;
  email: string;
  userName: string;
  nombre: string;
  apellido: string;
  imagen?: string;
  roles: string[];
  empresaId?: number;
  empresaNombre?: string;
  sucursalId?: number;
  sucursalNombre?: string;
  perfilPOS?: string;
  descuentoMaximo: number;
  permiteDevolucion: boolean;
  permiteAnular: boolean;
  permiteModificarPrecio: boolean;
}

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const { data } = await api.post<LoginResponse>('/usuario/login', credentials);
    return data;
  },

  getMe: async (): Promise<LoginResponse> => {
    const { data } = await api.get<LoginResponse>('/usuario/me');
    return data;
  },

  /**
   * Contexto POS en modo Ecolab. Mismo endpoint /usuario/me, pero el
   * backend devuelve otra forma: sin token (lo emite Ecolab) y con
   * requiereOnboarding, empresas, perfil y permisos.
   */
  getContexto: async (): Promise<ContextoPOS> => {
    const { data } = await api.get<ContextoPOS>('/usuario/me');
    return data;
  },

  register: async (data: {
    email: string;
    password: string;
    nombre: string;
    apellido: string;
    rol?: string;
  }): Promise<{ message: string; userId: string }> => {
    const { data: res } = await api.post('/usuario/register', data);
    return res;
  },

  cambiarPassword: async (passwordActual: string, passwordNuevo: string): Promise<void> => {
    await api.put('/usuario/cambiar-password', { passwordActual, passwordNuevo });
  },
};

export default authService;
